import React from 'react';
import intl from "react-intl-universal";


import {BackIcon} from "../../../components/icons/BackIcon";
import {useAppState} from "@stores/AppStateContext";



export const SettingsNavHeader = () => {
    const mobileNav = useAppState().mobileNavController;

    return (
        <div className={'theme-dark MobileHeader MobileHeader--simple'}>
            <BackIcon
                className={'MobileHeader__icon'}
                size={24}
                onClick={(event) => {
                    event.stopPropagation();
                    mobileNav.openMainSidebar();
                }}
            />
                <span className='title-medium' style={{ paddingRight: 16 }}>
                                {intl.get('navigation.settings').d('Settings')}
                </span>
        </div>
    )
}
